import * as React from "react";
import Navbar from './components/Navbar/Navbar';
import { Outlet, useLoaderData, useNavigation } from "react-router-dom";
import { useState } from 'react';
import Header from './components/common/Header/Header';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import { Grid } from "@mui/material";
import { MeResponse } from "./api";
import { SnackbarProvider } from 'notistack';



function App() {
  const [title, setTitle] = useState("");
  const me = useLoaderData() as MeResponse;
  const navigation = useNavigation();

  return (
    <SnackbarProvider anchorOrigin={{ horizontal: "center", vertical: "top" }}>
      <Box sx={{ display: 'flex' }} flexGrow={0}>
        <Header title={title} tenants={me.tenants} />
        <Navbar />
        <Box className={
          navigation.state === "loading" ? "loading" : ""
        } component="main" sx={{ width: '100%', p: 3, flexGrow: 0, maxWidth: "100%", overflow: 'scroll'}}>
          <Toolbar />
            <Outlet />
        </Box>
      </Box>
    </SnackbarProvider>
  );
}

export default App;
